import gql from 'graphql-tag';

const m = gql`
  mutation deleteCategoryStaticItem($_id: ID!) {
    deleteCategoryStaticItem(_id: $_id)
  }
`;

export default m;
